<template>
	<div>
		<el-drawer title="联系信息" size="840px" :append-to-body="true" :visible.sync="contactsDrawer">
			<div class="pt-24 pl-20 pr-20">
				<div class="flex-row-center-between">
					<div class="yx-pingfang-Medium fz-14 ml-20">联系人</div>
					<el-button type="primary" @click="relevancePerson" v-if="isLoginPartner && hasDrPartnerTag" v-auth="['system:talent:Construction']">
						{{ isThread ? '建联' : '+ 关联联系人' }}
					</el-button>
				</div>
				<el-table class="mt-16" :data="anchorContactList" header-row-class-name="table-header-row" row-class-name="table-row">
					<el-table-column prop="shipping_sn" min-width="160">
						<template slot="header">
							<span class="fz-12">联系人信息</span>
						</template>
						<template slot-scope="{ row }">
							<div class="flex-row-align-center">
								<yx-avatar :size="60" :src="row.avatar_url" />
								<div class="fz-12 ml-12 yx-color-g-9">
									<div class="name">
										{{ `${row.contact_name || ''}${row.contact_name && row.nick_name ? '-' : ''}${row.nick_name || ''}` }}
									</div>
									<div class="yx-color-text-secondary">微信号: {{ row.wechat_account ? row.wechat_account : '暂无' }}</div>
									<div class="yx-color-text-secondary">手机号: {{ row.mobile ? row.mobile : '暂无' }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="shipping_company" align="center" min-width="80">
						<template slot="header">
							<span class="fz-12">微信添加状态</span>
						</template>
						<template slot-scope="{ row }">
							<span :class="['font-h6-regular', row.is_add_wx === '1' ? 'success' : 'warning', 'des']">
								{{ row.is_add_wx === '1' ? '已加微信' : '未加微信' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="delivery_time" min-width="160">
						<template slot="header">
							<span class="fz-12">收货地址</span>
						</template>
						<template slot-scope="{ row }">
							<div v-if="Array.isArray(row.delivery_info)">暂无</div>
							<div v-else>
								<div class="font-h6-regular yx-color-text-primary">
									<span class="mr-10">{{ row.delivery_info.delivery_name }}</span>
									<span>{{ row.delivery_info.delivery_mobile }}</span>
								</div>
								<div class="font-h6-regular yx-color-text-regular">
									{{ row.delivery_info.province + row.delivery_info.city + row.delivery_info.area + row.delivery_info.delivery_addr }}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="add_time" label="" width="110">
						<template slot="header">
							<span class="fz-12">绑定时间</span>
						</template>
						<template slot-scope="{ row }">
							<span class="fz-12 yx-color-g-9">{{ row.add_time }}</span>
						</template>
					</el-table-column>
					<el-table-column min-width="80" align="center" header-align="right">
						<template slot="header">
							<span class="fz-12">操作</span>
						</template>
						<template slot-scope="{ row }">
							<div class="font-h6-regular text-align-right">
								<p class="cursor-pointer yx-color-primary" @click="skinContact(row)">查看该联系人</p>
								<p class="cursor-pointer yx-color-primary" v-if="!Array.isArray(row.delivery_info)" @click="copyAddress(row)">复制地址</p>
								<p class="cursor-pointer yx-color-primary" @click="editAddress(row)">编辑地址</p>
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<empty></empty>
					</template>
				</el-table>
			</div>
			<div class="talentCRM_myTalent_detail_aside_star_drawer_footer mt-20 yx-border-top">
				<el-button type="primary" @click="contactsDrawer = false">我知道了</el-button>
			</div>
		</el-drawer>
		<!--    编辑地址-->
		<AddressDialog ref="addressDialog" @getList="getInfo"></AddressDialog>
		<!--    建联记录-->
		<BuildContactDialog ref="buildContactDialog" @getList="getInfo" />
		<!--    关联联系人-->
		<linkman-dialog ref="linkmanDialog" @getList="getInfo" />
	</div>
</template>

<script>
import { getAnchorContactList } from '@/api/talentCRM';
import linkmanDialog from '@/views/talentCRM/components/linkmanDialog';
import BuildContactDialog from '@/views/talentCRM/components/buildContactDialog/index.vue';
import AddressDialog from '@/views/talentCRM/components/detailDrawer/components/addressDialog/index.vue';
import { mapGetters } from 'vuex';

export default {
	name: '',
	components: {  linkmanDialog, AddressDialog, BuildContactDialog },
	data() {
		return {
			contactsDrawer: false,
			anchorContactList: [],
		};
	},
	props: {
		anchor_info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	computed: {
		...mapGetters(['hasDrPartnerTag']),
		isThread() {
			return !this.anchorContactList.length;
		},
		isLoginPartner() {
			const { user_id = '', partners = [] } = this.anchor_info;
			return partners.some(item => item.user_id == user_id);
		},
	},
	methods: {
		show() {
			this.contactsDrawer = true;
			this.getInfo();
		},
		async getInfo() {
			const { code, data: { list = [] } = {} } = await getAnchorContactList({ anchor_id: this.anchor_info.anchor_id });
			if (code !== 0) return;
			this.anchorContactList = list;
			this.$emit('getList');
		},
		relevancePerson() {
			this.isThread ? this.showBuildContactDialog() : this.showLinkmanDialog();
		},
		showBuildContactDialog() {
			this.$refs.buildContactDialog.show({ anchor_id: this.anchor_info.anchor_id, ...this.anchor_info });
		},
		showLinkmanDialog() {
			this.$refs.linkmanDialog.show(
				{
					anchor_id: this.anchor_info.anchor_id,
					operate_time: Date.now(),
					is_pass: 1,
					contact_type: 1,
				},
				this.anchor_info,
			);
		},
		editAddress({ delivery_info, contact_id }) {
			console.log(delivery_info, contact_id);
			this.$refs.addressDialog.show(delivery_info, contact_id);
		},
		copyAddress({ delivery_info }) {
			let copy_value = `收件人：${delivery_info.delivery_name}\r\n收件电话：${delivery_info.delivery_mobile}\r\n收件地址：${
				delivery_info.province + delivery_info.city + delivery_info.area + delivery_info.delivery_addr
			}`;
			var inputTest = document.createElement('textarea');
			inputTest.value = copy_value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
		//跳转到联系人
		skinContact({ contact_id }) {
			const routeLink = this.$router.resolve({
				path: '/talentCRM/contacts',
				query: {
					contact_id,
				},
			});
			window.open(routeLink.href, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.talentCRM_myTalent_detail_aside_star_drawer_footer {
	position: absolute;
	bottom: 0;
	left: 0;
	padding: 24px;
	width: 100%;
	text-align: right;
}
</style>
